import { httpClient, type ID } from '#shared'
import type { AddReactionPayload } from '../models/add-reaction-payload'
import type { AddReactionResponse } from '../models/add-reaction-response'

export async function addReaction(chatId: ID, messageId: ID, payload: AddReactionPayload) {
  const response = await httpClient.post<AddReactionResponse>(`chats/${chatId}/messages/${messageId}/reactions`, {
    json: payload,
    requireAuth: true,
  })

  const responseBody = await response.json()

  return responseBody
}
